module.exports = __webpack_public_path__ + "static/img/5.3a5ec3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news28/5.png
// module id = x6Bg
// module chunks = 1